



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import HelperOffset from '@/components/helper/Offset/index.vue';

@Component({
  name: 'MaterialCard',
  components: {
    HelperOffset,
  },
})
export default class extends Vue {
  @Prop({ default: 'primary' }) private color!: string;
  @Prop({ default: 10 }) private elevation!: number | string;
  @Prop({ default: 10 }) private headerElevation!: number | string;
  @Prop({ default: false }) private inline!: boolean;
  @Prop({ default: false }) private fullWidth!: boolean;
  @Prop({ default: 24 }) private offset!: number | string;
  @Prop({ default: undefined }) icon!: string;
  @Prop({ default: undefined }) private title!: string;
  @Prop({ default: undefined }) private text!: string;

  get hasOffset() {
    return this.$slots.header || this.$slots.offset || this.title || this.text;
  }

  get styles() {
    if (!this.hasOffset) return null;
    return {
      marginBottom: `${this.offset}px`,
      marginTop: `${parseInt(this.offset as string) * 2}px`,
    };
  }
}
